module.exports = __webpack_public_path__ + "img/暴雪.3fcefa55.png";